import React from 'react';
import { FaCheckCircle, FaArrowCircleDown, FaExclamationCircle } from 'react-icons/fa';
import './InstituteModule.css';
import campusImg from '../Images/institute.png'; // Replace with your actual image
import { Link } from 'react-router-dom';

const InstituteModule = () => {
  return (
    <>
    <br></br>
    <br></br>
    {/* <br></br>
    <br></br> */}
    <div className="institute-wrapper">
      
      <div className="institute-left">
        <p className="section-label">INSTITUTE CAREER CENTRES</p>
        <h1>
          <span className="blue-text">AI-Powered</span> Future-ready career platform<br/>
          designed for institutes
        </h1>
        <p className="description">
        Empower your institute or academy with AI-based workflows<br />
            that simplify tasks, measure performance, and improve results.

        </p>
        <div class="demo-button-wrapper">
        <Link to="/BookDemoForm"><button className="demo-button">SCHEDULE A DEMO</button></Link>
        </div>
      </div>

      <div className="institute-right">
        <div className="image-container">
          <img src={campusImg} alt="Institute" className="institute-image" />

          <div className="status-card">
            <div className="status-row">
              <FaCheckCircle className="status-icon green" />
              <span className="status-text">3 interviews lined up</span>
              <div className="status-bar">
                <div className="bar-fill green-fill"></div>
              </div>
            </div>

            <div className="status-row">
              <FaArrowCircleDown className="status-icon yellow" />
              <span className="status-text">Fewer activities</span>
              <div className="status-bar">
                <div className="bar-fill yellow-fill"></div>
              </div>
            </div>

            <div className="status-row">
              <FaExclamationCircle className="status-icon red" />
              <span className="status-text">Not applying to roles</span>
              <div className="status-bar">
                <div className="bar-fill red-fill"></div>
              </div>
            </div>
          </div>

          
        </div>
      </div>
    </div>
    </>
  );
};

export default InstituteModule;